export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9845.f9890284.jpg";